import { Box, Paper, Typography, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";

import LockIcon from "@mui/icons-material/Lock";

export default function RestrictedAccess(props) {
	const {message}	= props;
	
	return (
		<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", bgcolor: "background.default"}}>
			<Paper elevation={4} sx={{p: 4, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
				<LockIcon color="primary" sx={{ fontSize: 50 }} />
				<Typography variant="h6">Recurso disponível apenas para usuários cadastrados</Typography>
				<Typography variant="body2" color="text.secondary">{ message || 'Faça login para continuar e desbloquear este recurso.'}</Typography>

				<Button component={Link} to="/login" variant="contained" color="primary" sx={{ m: 2 }} state={{ from: { pathname: window.location.pathname }}}>
					Ir para Login
				</Button>
				
				<Divider sx={{ width: "100%", my: 1 }} />

				<Typography variant="h6">Não tem cadastro? Cadastre-se! É GRÁTIS!</Typography>
				<Button component={Link} to="/register" variant="contained" color="primary" sx={{ m: 2 }} state={{ from: { pathname: window.location.pathname }}}>
					Cadastre-se Gratuitamente
				</Button>					
					
			</Paper>
		</Box>
	);
}
